// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("D:\\www\\xcite-homepage\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-beta-js": () => import("D:\\www\\xcite-homepage\\src\\pages\\beta.js" /* webpackChunkName: "component---src-pages-beta-js" */),
  "component---src-pages-index-js": () => import("D:\\www\\xcite-homepage\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "D:\\www\\xcite-homepage\\.cache\\data.json")

